import { render, staticRenderFns } from "./DropUp.vue?vue&type=template&id=554d41c0&"
import script from "./DropUp.vue?vue&type=script&lang=ts&"
export * from "./DropUp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports